/** @format */

import angular from 'angular';

import { EditToolsModule } from './edit-tools';
import { WidgetModule } from './widget';

export const ComponentsModule = angular.module('galabid-presenter.components', [EditToolsModule, WidgetModule]).name;
